module.exports = __webpack_public_path__ + "static/media/Artikal2.01454fe5.png";